import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";

export interface FormValidityState {
  [formKey: string]: boolean;
}

const initialState: FormValidityState = {};

const formValiditySlice = createSlice({
  name: "formValidity",
  initialState,
  reducers: {
    setFormValidity: (
      state,
      action: PayloadAction<{ formKey: string; isValid: boolean }>,
    ) => {
      const { formKey, isValid } = action.payload;
      state[formKey] = isValid;
    },
    clearFormValidity: (state, action: PayloadAction<{ formKey: string }>) => {
      delete state[action.payload.formKey];
    },
    resetAllValidities: () => initialState,
  },
});

export const { setFormValidity, clearFormValidity, resetAllValidities } =
  formValiditySlice.actions;

export const persistFormValidityConfig = {
  version: 1,
  key: "mpg_next_admin_program_v1",
  storage,
  whitelist: [],
};

export default formValiditySlice.reducer;
